<template>
  <div id="qy">
    <Header @refreshLogin="clickEven" :info='uInfo' :loginstatus="loginstatus"/>
    <div style="height:88px;"></div>
    <router-view style="" @refreshLogin="clickEven" :loginstatus="loginstatus"/>
    <Footer/>
  </div>
</template>

<script  type="text/javascript">
import { getCurrentInstance, onMounted, ref, watch } from "vue";
import Header from '@/components/header'
import Footer from '@/components/footer'
import { refreshUserInfo } from '@/utils/utils'
import { checkLogin } from '@/utils/api'
export default{
    data(){
      return{
        ismodel:false,
        uInfo:{},
        loginstatus:false,

      }
    },
    components:{
      Header,
      Footer
    },
    mounted(){
      this.clickEven()
      
    },
    methods:{
      clickEven(){
        checkLogin().then(res=>{
          this.loginstatus = res.data
          if(res.data)refreshUserInfo()
        })
      }
    }
  }
</script>

<style>
*{
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	color: #666666;
	list-style: none;
  text-decoration: none;
}

body{
	background-color: #FFFFFF;
  font-family: PingFangSC-Medium, PingFang SC;
}
#qy{
  width: 100%;
  min-width: 1200px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
img{
  display: block;
}
p,tr,td,span,div,a {
  font-weight: normal;font-weight: lighter;
   font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", 
   Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", 
   "Segoe UI Emoji", "Segoe UI Symbol";
}
.elltext2 {
  overflow: hidden ;
  white-space: pre-wrap;
  display: -webkit-box ;
  text-overflow: ellipsis;
  word-break: break-all; 
  -webkit-line-clamp:2;    
  -webkit-box-orient: vertical;
}

.elltext {
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis
}
.actColor{
  color: #FF2A2A !important;
}
.dis-flex{
  display: flex;
}
.flex-row-center{
  display: flex;
  align-items: center;
}
.flex-column{
  display: flex;
  flex-direction: column;
}
.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.routerviewmain{
  padding-top: 88px;
}
.txtOverFlow1{
  overflow: hidden; 
  text-overflow: ellipsis; 
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.txtOverFlow2{
  overflow: hidden; 
  text-overflow: ellipsis; 
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.cursorPointer{
  cursor: pointer;
}
p{
  font-weight: normal;font-weight: lighter;
}
</style>
